export default {
  label: {
    emptyData: {
      title: 'Não há dados para o contrato e bot(s) selecionado(s)',
      description: 'Selecione outro contrato e outro bot nos filtros para ver os dados.',
    },
    emptyBot: {
      title: 'Não foi possível carregar os dados',
      description: 'Selecione um bot e um contrato nos filtros para ver os dados.',
    },
    error: {
      title: '',
      description: 'Erro ao carregar dados',
    },
    supportsOnlyOneBot: {
      title: 'Não foi possível carregar os dados',
      description: 'Esse componente só suporta a seleção de um bot por vez.',
    },
  },
};
